import React from "react"
import propTypes from "prop-types"

import iconError from "./images/icon-error.svg"

const ErrorMessage = ({ message }) => {
  return (
    <>
      {message && (
        <div className="form_message">
          <img className="form_message_icon" src={iconError} alt="icon error" />{" "}
          {message}
        </div>
      )}
    </>
  )
}

ErrorMessage.propTypes = {
  message: propTypes.string
}

ErrorMessage.defaultProps = {
  message: ""
}

export default ErrorMessage
